import React from "react";
import { Form, Input } from "semantic-ui-react";

const UserInput = (props) => {
  const { value, onChange, disabled } = props;
  return (
    <Form.Field inline className="ml-1">
      <label>User:</label>
      <Input
        value={value}
        name="username"
        onChange={(e, { name, value }) => onChange(name, value)}
        disabled={disabled}
      />
    </Form.Field>
  );
};

export default UserInput;
